import axios from "axios";
import {Vue} from "vue-class-component";
import {bindVmToErrorResponseInterceptor, errorResponseInterceptor} from './interceptors';

const httpClient = axios.create({
  baseURL: "/api",
  withCredentials: true,
});


export function bindInterceptors(vm: Vue): void {
  const bindedErrorInterceptor = bindVmToErrorResponseInterceptor(errorResponseInterceptor, vm);
  httpClient.interceptors.response.use((e) => e, bindedErrorInterceptor);
}

export default httpClient;
